import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Nftecosystem() {
  return (
    <section className="nft_ecosystem chatbot_process p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Chatbot Development Company: Developing Process-Specific
              Intelligent Chatbot Solutions
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Team Productivity</h5>
                  </div>
                  <p>
                    AI chatbots unlock multiple opportunities for team
                    productivity. You can use them for brainstorming,
                    note-taking, sending information, preparing schedules, and
                    even automate tasks that are repetitive, and result in no
                    value.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Logistics and Operations</h5>
                  </div>
                  <p>
                    Chatbot development solutions can add real value to logistic
                    and supply chain operations. Chatbots can fetch data for
                    tracking IDs, and update on status of shipping in real-time.
                    Besides, they can enhance the workflows of employees working
                    in logistics.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Streamline Recruitment</h5>
                  </div>
                  <p>
                    Our chatbot development services can come in handy to help
                    you automate screening of candidates. Chatbots will expedite
                    the screening process, and help you find the best candidate
                    with little to no need for intervention.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Prompt Complaint Response</h5>
                  </div>
                  <p>
                    Chatbot development can even create amazing possibilities in
                    avenues of customer management. Bots can handle requests,
                    queries, and even resolve complaints by leveraging NLP
                    techniques, thereby minimizing the impact of human-error
                    which often results in poor client experience.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Enhanced Search Performance</h5>
                  </div>
                  <p>
                    Seamless integration of chatbots also provides you the
                    facility to scan through large data sets. Access to search
                    engines can help to fetch, organize, and present useful
                    information in real-time. This is already proving as an
                    incredible tool as it saves your time for research,
                    particularly for people who don’t prefer a conventional
                    search interface.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Managing Customer Relations</h5>
                  </div>
                  <p>
                    Integrating chatbots in your sales and marketing workflows
                    saves you from memorizing important customer details and
                    carefully listening to calls. Chatbots can make
                    conversations more frequent, controlled, and engaging.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftecosystem;
